import { useCallback } from 'react';
import { useSMLRouter } from '../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { SMLUpgradeFeature } from '../../../music24/config/music24PlanCapabilities';
import { useMusic24Capabilities } from '../../../music24/hooks/useMusic24Capabilities';
import { useUpgradePrompt } from '../../../music24/hooks/useUpgradePrompt';

/**
 * Opens the pre-save screen of a catalog song (`/smartlinks/presaveLink?accountId=&catalogItemUuid=`,
 * design presave-create a1). The screen makes the page from the song. Nothing happens with no active
 * artist or an empty uuid. A plan with no pre-saves opens the plan prompt instead (design
 * presave-subscriptions d5); the server refuses the create with a 402 too.
 */
export function useOpenPresaveWizardForSong(): (catalogItemUuid: string) => void {
  const router = useSMLRouter();
  const accountId = useAccountId();
  const { canUsePresave } = useMusic24Capabilities();
  const openUpgrade = useUpgradePrompt();
  return useCallback(
    (catalogItemUuid: string) => {
      if (accountId === null || catalogItemUuid === '') {
        return;
      }
      if (!canUsePresave) {
        openUpgrade(SMLUpgradeFeature.presave);
        return;
      }
      router.push(SMLRoutes.presaveLink, { accountId, catalogItemUuid });
    },
    [accountId, canUsePresave, openUpgrade, router]
  );
}
